import { Outlet } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { hasRegularAccessOrNotEmployee } from 'modules/employees/lib/utils'
import { useEngagementContext } from 'modules/engagement/hooks/useEngagementContext'
import engagementAuthorization from 'modules/engagement/lib/authorization'
import CollectionsBootstrap from 'modules/engagement_insights/lib/CollectionsBootstrap'

import Upsell from './Upsell'

const Container = () => {
  const { employee: currentEmployee } = useCurrentSession()
  const { moduleAvailabilities } = useEngagementContext()

  const can = engagementAuthorization({ moduleAvailabilities, currentEmployee })

  if (!can.seeInsights) {
    return <Upsell />
  }

  return (
    <AuthorizeUser authorizeFn={() => hasRegularAccessOrNotEmployee(currentEmployee)}>
      <Outlet />
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
